﻿import { DateFieldValue, formatDateRelative, formatDateTime, parseDateLenient } from "helpers";
import React from "react";

interface DisplayDateRelativeProps {
  value?: DateFieldValue;
}

export const DisplayDateRelative: React.FC<DisplayDateRelativeProps> = ({ value }) => {
  if (!value) {
    return null;
  }

  const date = parseDateLenient(value);
  const tooltip = date ? formatDateTime(date) : "";
  const text = date ? formatDateRelative(date) : "-";

  return (
    <span title={tooltip} className="text-nowrap global-tooltip-trigger">
      {text}
    </span>
  );
};
